import { Injectable, inject } from '@angular/core';
import { Firestore, collection, getDocs, query, where, getDoc, doc } from '@angular/fire/firestore';
import { Topic } from '../entities/topic.model';
import { Observable, Subject, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopicService {
  private firestore: Firestore;
  private topicSelectedSource = new Subject<Topic>();
  topicSelected$ = this.topicSelectedSource.asObservable();

  constructor() {
    this.firestore = inject(Firestore);
  }

    getTopics(language: string): Observable<Topic[]> {
        const topicsCollection = collection(this.firestore, 'topics');
        const topicsQuery = query(topicsCollection, where('language', '==', language));
        return from(getDocs(topicsQuery).then(snapshot => 
        snapshot.docs.map(doc => ({ ...doc.data() } as Topic))
        ));
    }

    getTopicByNameAndLang(name: string, language: string): Observable<Topic | undefined> {
        const topicCollection = collection(this.firestore, 'topics');
        const topicQuery = query(topicCollection, where('name', '==', name), where('language', '==', language));
        return from(getDocs(topicQuery).then(snapshot => {
            if (snapshot.docs.length > 0) {
                return { ...snapshot.docs[0].data() } as Topic;
            } else {
                return undefined;
            }
        }));
    }

    selectTopic(topic: Topic) {
        this.topicSelectedSource.next(topic);
    }
}
